import { useMutation, useRequest } from "../../utils/api"
import { GeneralProps, ShortMutationConfigType } from "../../utils/api.type"
import { ListLocationResponseType, LocationTypeProps } from "../location/index.type"
import { CreateWaypointProps, DetailWaypointResponseType, ListWaypointResponseType, UpdateWaypointProps } from "./waypoint.type"

const ENDPOINT_CREATE_WAYPOINT = '/v1/rms/config/waypoint/store/'
export const useCreateWaypointMutation = (options: ShortMutationConfigType) => {
  return useMutation<any, CreateWaypointProps>(ENDPOINT_CREATE_WAYPOINT, {
    ...options
  })
}

const ENDPOINT_UPDATE_WAYPOINT = '/v1/rms/config/waypoint/update/'
export const useUpdateWaypointMutation = (options: ShortMutationConfigType) => {
  return useMutation<any, UpdateWaypointProps>(ENDPOINT_UPDATE_WAYPOINT, {
    ...options
  })
}

const GET_LIST_LOCATION = '/v1/rms/config/waypoint/'
export const DEFAULT_LOCATION_LIMIT = 100
export const useListConfigWaypoints = (type?: LocationTypeProps, obj = {} as {
  enabled?: boolean,
  pageSize?: number,
  page?: number,
  search?: string,
  building_uuid?: string
}) => {
  return useRequest<ListLocationResponseType>(GET_LIST_LOCATION, {
    ...obj,
    type: type || 'all',
    page_size: obj.pageSize || DEFAULT_LOCATION_LIMIT,
    page: obj.page || 1,
    search: obj.search || undefined,
    building_uuid: obj.building_uuid || undefined
  }, {
    enabled: obj.enabled
  })
}


const ENDPOINT_DETAIL_WAYPOINT = '/v1/rms/config/waypoint/detail/:uuid/'
export const useConfigDetailWaypoint = (obj = {} as GeneralProps & { uuid: string }) => {
  return useRequest<DetailWaypointResponseType>(ENDPOINT_DETAIL_WAYPOINT.replace(':uuid', obj.uuid), {},
    {
      enabled: obj.enabled,
      cacheKey: JSON.stringify(obj),
    })
}

const ENDPOINT_TYPE_WAYPOINT = '/v1/rms/config/waypoint/list_type/'
export const useConfigTypeWaypoint = (obj = {} as GeneralProps) => {
  return useRequest<ListWaypointResponseType>(ENDPOINT_TYPE_WAYPOINT, {
    ...obj
  }, {
    enabled: obj.enabled,
    cacheKey: JSON.stringify(obj),
  })
}

